export default __webpack_public_path__ + "static/media/minimize-risk-card.d0a7759d.png";